import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {BADGE_COLORS, BILLING_SUBSCRIPTION_STATUS} from '../../../common/constants';
import Badge from '../../../common/components/Badge';

const DisplayBillingSubscriptionStatus = ({t, status}) => {
  switch (status) {
  case BILLING_SUBSCRIPTION_STATUS.ACTIVE:
    return <Badge color={BADGE_COLORS.GREEN}>{t('subscriptionStatus.' + status)}</Badge>;
  case BILLING_SUBSCRIPTION_STATUS.CANCELED:
    return <Badge color={BADGE_COLORS.RED}>{t('subscriptionStatus.' + status)}</Badge>;
  case BILLING_SUBSCRIPTION_STATUS.UNPAID:
    return <Badge color={BADGE_COLORS.ORANGE}>{t('subscriptionStatus.' + status)}</Badge>;
  case BILLING_SUBSCRIPTION_STATUS.TRIALING:
    return <Badge color={BADGE_COLORS.BLUE}>{t('subscriptionStatus.' + status)}</Badge>;
  default:
    return <Badge color={BADGE_COLORS.GREY}>{t('subscriptionStatus.' + status)}</Badge>;
  }
};

DisplayBillingSubscriptionStatus.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};

export default withTranslation('billing')(DisplayBillingSubscriptionStatus);
